// Generated by ReScript, PLEASE EDIT WITH CARE


function getStatusfromSubStatus(status) {
  switch (status) {
    case /* Open */0 :
        return /* Open */3;
    case /* Allocated */1 :
    case /* Accepted */2 :
    case /* Live */3 :
    case /* Loading */4 :
    case /* Unloading */5 :
        return /* Live */0;
    case /* Ended */6 :
    case /* Completed */7 :
        return /* Completed */1;
    case /* Cancelled */8 :
    case /* Rescheduled */9 :
        return /* Cancelled */2;
    
  }
}

var OrderStatusSubStatusMapper = {
  getStatusfromSubStatus: getStatusfromSubStatus
};

function getColorCode(status) {
  var status$1 = getStatusfromSubStatus(status);
  switch (status$1) {
    case /* Live */0 :
        return "#2f8bff";
    case /* Cancelled */2 :
        return "#ff4674";
    case /* Completed */1 :
    case /* Open */3 :
        return "#3bc777";
    
  }
}

var OrderStatusColorMapping = {
  getColorCode: getColorCode
};

export {
  OrderStatusSubStatusMapper ,
  OrderStatusColorMapping ,
  
}
/* No side effect */
